<h4  class="text-center">
  <app-country-flag *ngIf="countryFlag" [countryImage]="countryFlag"></app-country-flag>

  Mathematics  <span>{{primaryLevelNaming}} </span> {{syllabusInfoResponse.gradeLevel}}({{countryName}})</h4>
<div class="row">
  <div class="col-sm-7">
<div  *ngIf="true" id="accordionSubjThemes" class="max-width">
   <app-topic-info
   *ngFor="let topic of syllabusInfoResponse.topics; index as i"
   [topic]="topic"
   [myCount]="i"
   (renderMathRequest)="renderMathPage($event)">
   </app-topic-info>

  </div>
  <p class="text-center py-2">
   <a *ngIf="!is_logged_in" [routerLink]="['/user/new/step/one']"  class="btn btn-primary mx-1"> Enrol Now</a>
   <a *ngIf="is_logged_in"  routerLink="/home/show" class="btn btn-primary mx-1"> Enrol Now</a>
   <button (click)="downloadapp()" class="btn btn-primary mx-1">
     Download App
     <img src="/assets/images/play_prism_hlock_2x.png" width="100px">
    </button>
  </p>
  </div>
  <div class="col-sm-5">
  <div *ngFor="let imageId of syllabusInfoResponse.levelimages;" class="div-spacer">
        <img src="/assets/images/level-info/detail/detail{{ imageId }}.png" width="100%">
  </div>
  </div>
  </div>
  <app-country-level-syllabus></app-country-level-syllabus>
  <span *ngIf="renderMathNow" [appMath]="''"></span>
